<template lang="pug">
    router-link.battles-banner(:to="link")
        img.battles-banner__gif(src="gifs/battles.gif")
</template>

<script>
    export default {
        props: {
            userType: String,
            userIsSuperadmin: Boolean,
        },
        computed: {
            link() {
                if ((this.userType === 'teacher' || this.userType === 'admin') && !this.userIsSuperadmin)
                    return { name: 'dashboard' };
                return '/battles';
            }
        },
    }
</script>

<style lang="scss" scoped>
    .battles-banner {
        display: block;
        overflow: hidden;

        border-radius: $border-radius-20;
        background-color: $x-color-white;
    }
    .battles-banner__gif {
        width: 100%;
        outline: 2px solid $hsl-color-gray-98;
        outline-offset: -2px;
    }
</style>
